import React, { useState } from "react";
import "./InternshipApplication.css";
import UiImage from "../../assets/developementservices/ui-image.png";
import { Bounce, toast, ToastContainer } from "react-toastify";
import API_BASE_URL from "../../config";

const InternshipForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    internshipType: "",
    message: "",
    resume: null,
    website: "", // ← honeypot field
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    // alert("✅ Application Submitted Successfully!");

    // Validation
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim() ||
      !formData.internshipType.trim() ||
      !formData.resume
    ) {
      setStatus("Please fill out all fields and attach your resume.");
      return;
    }

    // Email format validation
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setStatus("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("message", formData.message);
      data.append("internshipType", formData.internshipType);
      data.append("resume", formData.resume); // Attach file
      data.append("website", formData.website); // Honeypot

      // Optional: debug FormData
      for (let [key, value] of data.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_URL}/internship`, {
        method: "POST",
        body: data, // Browser sets Content-Type automatically
      });

      const result = await response.json();
      console.log(result)

      if (!response.ok) {
        throw new Error(result.message || "Something went wrong");
      }

      toast.success("We'll connect with you ASAP!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      setStatus(result.message || "Application sent successfully!");

      // Reset form including file and internship type
    } catch (error) {
      toast.error("Something went wrong! Try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      console.error("Send message error:", error);
      setStatus("Failed to send message: " + error.message);
    } finally {
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        internshipType: "",
        message: "",
        resume: null,
        website: "",
      });
    }
  };

  return (
    <section className="internship-hero-section">
      <div className="internship-hero-content">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <h1>
          Apply for <span className="highlight-script">Internship</span>
        </h1>
        <p>
          Fill out the form below to join our internship program and start your
          career journey.
        </p>
        {/* <div className="form-container">
          <div className="form-image-container">
            <img src={formImage} alt="Apply Internship" />
          </div>

          <form className="internship-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              value={formData.phone}
              onChange={handleChange}
            />

            <select
              name="internshipType"
              required
              value={formData.internshipType}
              onChange={handleChange}
            >
              <option value="">Select Internship Type</option>
              <option value="uiux">UI/UX Design</option>
              <option value="mobile">Mobile App Development</option>
              <option value="web">Website Development</option>
              <option value="custom">Custom App Development</option>
              <option value="hr">Human Resources</option>
              <option value="marketing">Digital Marketing</option>
            </select>

            <textarea
              name="message"
              placeholder="Why do you want this internship?"
              rows="4"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <input
              type="file"
              name="resume"
              accept=".pdf,.doc,.docx"
              onChange={handleChange}
            />
            <div className="btn-container">
              <button type="submit" className="internship-apply-now-btn">
                <span className="btn-text">Submit Application</span>
                <span className="btn-circle">📤</span>
              </button>
            </div>
          </form>
        </div> */}
        <div className="form-section">
          {/* Left side: Image */}
          <div className="form-image-container">
            <img src={UiImage} alt="Apply Internship" />
          </div>

          {/* Right side: Form */}
          <div className="form-container">
            <form className="internship-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                required
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                required
                value={formData.phone}
                onChange={handleChange}
              />

              <select
                name="internshipType"
                required
                value={formData.internshipType}
                onChange={handleChange}
              >
                <option value="">Select Internship Type</option>
                <option value="uiux">UI/UX Design</option>
                <option value="mobile">Mobile App Development</option>
                <option value="web">Website Development</option>
                <option value="custom">Custom App Development</option>
                <option value="hr">Human Resources</option>
                <option value="marketing">Digital Marketing</option>
              </select>

              <textarea
                name="message"
                placeholder="Why do you want this internship?"
                rows="4"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
              />

              <div className="btn-container">
                <button type="submit" className="internship-apply-now-btn">
                  <span className="btn-text">
                    {loading ? "Sending..." : "Submit Application"}
                  </span>
                  <span className="btn-circle">📤</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternshipForm;
